import { apiService } from './axios.client';
export const UserEndPoints = {
    getUserById: function (input, callback) {
        apiService.get('/user/getUserById', input)
            .then((response) => callback(response))
            .catch(error => alert(error));
    },
    getUserAnalyticsById: function (input, callback) {
        apiService.get('/user/GetUserLoginAnById', input)
            .then((response) => callback(response))
            .catch(error => alert(error));
    },
    setOptimizeSession: function (input, callback) {
        apiService.post('/UserSession/setOptimizeSession', input)
            .then((response) => callback(response, input))
            .catch(callback());
    },
    updateOptimizeSession: function (input, callback) {
        apiService.post('/UserSession/updateOptimizeSession', input)
            .then((response) => callback(response, input))
            .catch(error => callback(error.response.data.message));
    },
    getOptimizeSessionDescription: function (input, callback) {
        apiService.get('/UserSession/getOptimizeSessionDescription', input)
            .then((response) => callback(response))
            .catch(error => callback(error));
    },
    getOptimizeSessionById: function (input, callback) {
        apiService.get('/UserSession/getOptimizeSessionById', input)
            .then((response) => callback(response))
            .catch(error => callback(error));
    },
    getAllOptimizeSession: function (input, callback) {
        apiService.get('/UserSession/getOptimizeSession', input)
            .then((response) => callback(response))
            .catch(error => callback(error));
    },
    deleteOptimizeSession: function (input, callback) {
        apiService.post('/UserSession/deleteOptimizeSession', input)
            .then((response) => callback(response))
            .catch(error => callback(error));
    },
    getLrsr: function (input, callback) {
        apiService.get('/UserSession/getLrsr', input)
            .then((response) => callback(response))
            .catch(error => alert(error));
    },
    getLrs: function (input, callback) {
        apiService.get('/UserSession/getLrs', input)
            .then((response) => callback(response))
            .catch(error => alert(error));
    },
    importOptimizeSession: function (input, callback) {
        apiService.post('/UserSession/setOptimizeSessionByLrs', input)
            .then((response) => callback(response, input))
            .catch(error => alert(error.response.data.message));
    },
    updatePassword: function (input, callback) {
        apiService.post('/user/updatePassword', input)
            .then((response) => callback(response, input))
            .catch(error => callback(error.response));
    },
    sendResetEmail: function (input, callback) {
        apiService.post('/user/sendResetEmail', input)
            .then((response) => callback(response, input))
            .catch(error => callback(error.response));
    },
    getUserLogin: function (input, callback) {
        apiService.get('/user/getUserLogin', input)
            .then((response) => callback(response))
            .catch(error => callback(error.response));
    },
    resetPassword: function (input, callback) {
        apiService.post('/user/resetPassword', input)
            .then((response) => callback(response, input))
            .catch(error => callback(error.response));
    },
    sendSupportRequest: function (input, callback) {
        apiService.post('/user/sendSupportRequestEmail', input)
            .then((response) => callback(response, input))
            .catch(error => callback(error.response));
    },
    getRSSFeed: function (input, callback) {
        apiService.get('/user/getRSSFeed', input)
            .then((response) => callback(response, input))
            .catch(error => callback(error));
    },
    editUser: function (input, callback) {
        apiService.post('/User/editUser', input)
            .then((response) => callback(response, input))
            .catch(error => callback(error));
    },
    getCompany: function (input, callback) {
        apiService.get('/User/getCompany', input)
            .then((response) => callback(response, input))
            .catch(error => callback(error));
    },
};